import { Navigate } from "react-router-dom";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { PageLoader } from "@/components/common";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <PageLoader className="min-h-screen bg-ink-950" />;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="font-display text-3xl sm:text-4xl" data-testid="admin-page-title">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-neutral-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Field = ({ label, hint, className = "", children }) => (
  <div className={`space-y-2 ${className}`}>
    <Label className="text-[11px] uppercase tracking-[0.15em] text-neutral-400">{label}</Label>
    {children}
    {hint && <p className="text-xs text-neutral-500">{hint}</p>}
  </div>
);

export const StatCard = ({ label, value, icon: Icon, tone = "neutral", hint, testId }) => {
  const tones = { neutral: "text-white", gold: "text-gold-light", rose: "text-rose-300", emerald: "text-emerald-300", amber: "text-amber-300" };
  return (
    <div data-testid={testId} className="panel p-4 sm:p-5">
      <div className="flex items-center justify-between gap-2">
        <p className="text-[10px] uppercase tracking-[0.2em] text-neutral-500 sm:text-[11px]">{label}</p>
        {Icon && <Icon className="h-4 w-4 shrink-0 text-neutral-600" />}
      </div>
      <p className={`mt-4 break-words font-mono text-base sm:text-xl xl:text-[1.35rem] ${tones[tone]}`} data-testid={`${testId}-value`}>{value}</p>
      {hint && <p className="mt-1 text-xs text-neutral-500">{hint}</p>}
    </div>
  );
};
